import { isEmpty } from '@ember/utils';
import { saveAs } from 'file-saver';

export function downloadFromBytes(byteData, mimeType, fileName) {
  if (isEmpty(byteData) || isEmpty(mimeType) || isEmpty(fileName)) {
    return;
  }
  let sliceSize = 512;
  let byteCharacters = atob(byteData);
  let byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    let slice = byteCharacters.slice(offset, offset + sliceSize);

    let byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    let byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  saveAs(new Blob(byteArrays, { type: mimeType }), fileName);
}

export function getNzMoeRollReturnFileName(
  jurisdictionId,
  rollReturn,
  fileType,
  extension,
) {
  let year = rollReturn.rollReturnYear.toString().substring(2, 4);
  return `${jurisdictionId}${rollReturn.rollReturnMonth}${year}${fileType}.${extension}`;
}
